import type { ResearchKeywordCreateDto, ResearchKeywordSelectDto } from '@@types/api.types';
import { useAuth0 } from '@auth0/auth0-react';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './keys';
import { useGetCurrentUser } from './users.query';

export const useInnovatorGetResearchKeywords = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const { isInnovator } = useGetCurrentUser();
  const enabled = Boolean(isAuthenticated && isInnovator);

  return useQuery<ResearchKeywordSelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      return await apiGet<ResearchKeywordSelectDto[]>({
        path: '/v1/innovator/research-keywords',
      });
    },
    queryKey: enabled ? queryKeys.researchKeywords.getResearchKeywords : queryKeys.placeholders.default,
  });
};

export const useInnovatorCreateResearchKeyword = () => {
  const { apiPost } = useApi();
  const queryClient = useQueryClient();

  return useMutation<ResearchKeywordSelectDto, ApiErrorWrapper, Pick<ResearchKeywordCreateDto, 'name'>>({
    mutationFn: async (data) => {
      return await apiPost<ResearchKeywordSelectDto>({
        body: data,
        path: '/v1/innovator/research-keywords',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.researchKeywords.getResearchKeywords,
      });
    },
  });
};
